
//Dependencies
import React, { Component } from 'react';
import { isMobile } from 'react-device-detect';

//material-ui
import Grid from '@material-ui/core/Grid';

//Assets
import logoMobile from '../../../static/img//header/logo-bh.png';
import logoDesktop from '../../../static/img//header/logo-bh@2x.png';

class Header extends Component {

    render() {
        console.log("--------isMobile------------")
        console.log( isMobile )
        console.log("--------------------")

        let styleMobile =  ( isMobile ) ? {}:{display:"none"} 
        let styleDesktop =  ( !isMobile ) ? {}:{display:"none"} 

        return (
            <div className="header-image">
                <div className="header-container">
                    <Grid container >
                        <Grid item xs={12} >
                            <img style={styleMobile} src={logoMobile}  />
                            <img style={styleDesktop} src={logoDesktop}  />
                        </Grid>
                        <Grid item xs={12} sm={8} md={8} className="header-description" >
                            Hacé un <strong>Plazo Fijo,</strong> <br />
                            <strong>sin ser cliente y</strong> <br />
                            <strong>sin costo.</strong>
                        </Grid>
                    </Grid>
                </div>
            </div>
        );
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/PlazoFijo/landingPage/Header.js